import { Grid } from '@mui/material';

// Components
import { IBookmarkPeople } from 'src/model/bookmark';
import PeopleBookmarkCard from 'src/features/Bookmark/PeopleBookmarkList/PeopleBookmarkCard';

interface IListPeopleBookmarkProps {
  listBookmark: IBookmarkPeople[];
}

const PeopleBookmarkList = ({ listBookmark }: IListPeopleBookmarkProps) => {
  return (
    <Grid container spacing={2}>
      {listBookmark.map((dataBookmark: IBookmarkPeople, index) => {
        return (
          <Grid xs={12} md={6} lg={6} xl={6} key={`people-bookmark-${dataBookmark.uuid}-${index}`} item>
            <PeopleBookmarkCard dataBookmark={dataBookmark} />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default PeopleBookmarkList;
